import form_module_default from "./form.module.js";
import classNames from "classnames";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
import { Label } from "@radix-ui/react-form";
//#region src/components/Form/Label.tsx
/**
* Thin wrapper around Radix UI Label component
* https://www.radix-ui.com/docs/primitives/components/form#label
*/
var Label$1 = forwardRef(function Label$2({ children, ...props }, ref) {
	const classes = classNames(form_module_default.label, props.className);
	return /* @__PURE__ */ jsx(Label, {
		ref,
		...props,
		className: classes,
		children
	});
});
//#endregion
export { Label$1 as Label };

//# sourceMappingURL=Label.js.map